module.exports = __webpack_public_path__ + "static/media/icon_menu.794b4f8d.svg";